import { getToken } from "@/utils/rest/RestClient";
import DownloadIcon from "@static/core/icons/icon-download.svg?react";
import { Bill } from "@type/core/offices/offices.types";
import { SEALED_STATUS_ENUM } from "@utils/Constant";
import { ColumnsType } from "antd/lib/table/interface";
import i18n from "i18next";

export const columns = (): ColumnsType<Bill> => [
  {
    title: i18n.t("offices.balanceAndStatistics.headers.billNumber"),
    dataIndex: "billNumber",
    className: "text-center",
  },
  {
    title: i18n.t("offices.balanceAndStatistics.headers.date"),
    dataIndex: "date",
    className: "text-center",
  },
  {
    title: i18n.t("offices.balanceAndStatistics.headers.amountToPay"),
    dataIndex: "amountToPay",
    className: "text-center",
  },
  {
    title: i18n.t("offices.balanceAndStatistics.headers.user"),
    dataIndex: "userName",
    className: "text-center",
  },
  {
    title: i18n.t("offices.balanceAndStatistics.headers.download"),
    dataIndex: "billStatus",
    className: "text-center",
    render: (billStatus: string, record: Bill) => {
      return SEALED_STATUS_ENUM.indexOf(billStatus) !== -1 ? (
        <a
          href={`${record.path}?token=${getToken()}`}
          // download
          target="_blank"
          title={i18n.t("download")}
          rel="noreferrer"
        >
          <DownloadIcon className="text-black icon-30" />
        </a>
      ) : (
        <span
          title={i18n.t("offices.balanceAndStatistics.status." + billStatus)}
          className="text-right overflow-ellipsis"
        >
          {i18n.t("offices.balanceAndStatistics.status." + billStatus)}
        </span>
      );
    },
  },
];
